import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import React, { Component } from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import { ReducerTypes } from "./constant";
import { Exitreasons } from "./ExitActions";
import "./exitreasons.css";

import { isSpaceInString } from "Utils";

const POST_DATA = {
  subscriptionexitreasonid: null,
  reasontypeid: null,
  reason: "",
  subscriptionid: null,
  isactive: null,
};

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: { ...POST_DATA },
    };
    this.updatePostData = this.updatePostData.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillUnmount() {
    this.updatePostData({ ...POST_DATA });
  }

  componentDidMount() {
    let DATA;
    if (this.props.onCreate) {
      DATA = { ...POST_DATA };
    } else {
      DATA = this.props.editData;
    }
    this.setState({ postData: DATA });
  }

  updatePostData(key, value) {
    const { postData } = this.state;
    postData[key] = value;
    this.setState({ postData });
  }

  onSubmit() {
    const { subscriptionexitreasonid, reasontypeid, isactive } = get(
      this.state,
      "postData",
      "",
    );

    // this.props.Exitreasons(ReducerTypes.EXITREASONSPOLICY, data);
    if (
      this.state.postData.reason &&
      !isSpaceInString(this.state.postData.reason)
    ) {
      this.state.postData.reason = this.state.postData.reason.trim();
    }

    const data = {
      subscriptionexitreasonid,
      reasontypeid: parseInt(reasontypeid),
      reason: this.state.postData.reason,
      isactive: isactive || false,
    };

    if (!this.state.postData.reason) {
      this.props.enqueueSnackbar("Please enter name", { variant: "error" });
    } else if (!reasontypeid) {
      this.props.enqueueSnackbar("Please select reason type", {
        variant: "error",
      });
    } else {
      instance
        .post("exit/reason", data)
        .then(() => {
          this.props.enqueueSnackbar("saved successfully", {
            variant: "success",
          });
          this.props.getExitReasons();
          this.props.history.push("/config/hris/employee/exit_reason");
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const { reasontypeid, reason, subscriptionexitreasonid } =
      this.state.postData;
    return (
      <IntlProvider locale="en">
        <div className="margin-bottom-30 main-profile-outer display-block">
          <div>
            <h5>Type:</h5>
          </div>
          <div>
            <div style={{ width: "100%", height: 119 }}>
              <div
                className="depedent-select-list"
                aria-expanded={reasontypeid == 1}
                onClick={() => this.updatePostData("reasontypeid", 1)}
                style={{ borderTop: "none !important" }}
              >
                <span>
                  <FormattedMessage id="#" defaultMessage="Resignation" />
                </span>
                {reasontypeid == 1 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected"></span>
                )}
              </div>
              <div
                className="depedent-select-list"
                aria-expanded={reasontypeid == 2}
                onClick={() => this.updatePostData("reasontypeid", 2)}
              >
                <span>
                  <FormattedMessage id="#" defaultMessage="Termination" />
                </span>
                {reasontypeid == 2 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected"></span>
                )}
              </div>
            </div>
          </div>
          <Grid style={{ marginTop: 20 }}>
            <div>
              <div className="form-group" style={{ marginTop: 15 }}>
                <p className="input-form-label" style={{ color: "black" }}>
                  What is the exit reason?
                </p>
                <textarea
                  multiline
                  id="outlined-multiline"
                  style={{
                    width: "700 !important",
                    height: 50,
                    padding: "10 !important",
                  }}
                  margin="dense"
                  variant="outlined"
                  value={reason}
                  onChange={(e) =>
                    this.updatePostData("reason", e.target.value)
                  }
                />
              </div>
            </div>
            <div>
              <Button
                color="primary"
                variant="contained"
                onClick={this.onSubmit}
              >
                {!subscriptionexitreasonid ? "Create" : "Update"}
              </Button>
            </div>
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      Exitreasons: (type, data) => Exitreasons(type, data),
    },
    dispatch,
  );

const mapStateToProps = (state) => ({
  ExitReasonsReducer: state.ExitReasonsReducer,
});
export default connect(mapStateToProps, mapDispatchToProps)(Create);
